import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {
    torchGuy1: {
        type: 'movieclip',
        scale: {
            y: '40%'
        },
        position: {
            x: '-16%',
            y: '-4.9%'
        },
        /* texture: [
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-0.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-1.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-2.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-3.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-4.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-5.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-6.png',
            '/img/partials/blobs-treadmill/torch-guy/1/torch-guy-7.png'
        ], */
        texture: `sprite:/img/partials/blobs-treadmill/torch-guy-${prefix}.json,torch-guy/1`,
        effectSpriteKey: 'torchGuyEffect',
        effectPositions: [
            [{
                position: {
                    x: '22.2%',
                    y: '72.5%'
                },
                rotation: 10
            }],
            [{
                position: {
                    x: '35.3%',
                    y: '17.6%'
                },
                rotation: -160
            }],
            [{
                position: {
                    x: '52.5%',
                    y: '77%'
                },
                rotation: -30
            }],
            [{
                position: {
                    x: '66%',
                    y: '74%'
                },
                rotation: -30
            }],
            [{
                position: {
                    x: '46.3%',
                    y: '13.5%'
                },
                rotation: -165
            }],
            [{
                position: {
                    x: '61.2%',
                    y: '30%'
                },
                rotation: -120
            }],
            [{
                position: {
                    x: '19.7%',
                    y: '66.4%'
                },
                rotation: 8
            }],
            [{
                position: {
                    x: '46.2%',
                    y: '75.5%'
                },
                rotation: -10
            }]
        ]
    },

    torchGuy2: {
        type: 'movieclip',
        scale: {
            y: '40%'
        },
        position: {
            x: '-16%',
            y: '-4.9%'
        },
        /*texture: [
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-0.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-1.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-2.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-3.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-4.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-5.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-6.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-7.png',
            '/img/partials/blobs-treadmill/torch-guy/2/torch-guy-8.png'
        ],*/
        texture: `sprite:/img/partials/blobs-treadmill/torch-guy-${prefix}.json,torch-guy/2`,
        effectSpriteKey: 'torchGuyEffect',
        effectPositions: [
            [{
                position: {
                    x: '15%',
                    y: '72.7%'
                },
                rotation: 14
            }],
            [{
                position: {
                    x: '38%',
                    y: '76%'
                },
                rotation: -9
            }],
            [{
                position: {
                    x: '36%',
                    y: '79.5%'
                },
                rotation: 3
            }],
            [{
                position: {
                    x: '13.3%',
                    y: '73.2%'
                },
                rotation: 11
            }],
            [{
                position: {
                    x: '83.2%',
                    y: '79%'
                },
                rotation: -39
            }],
            [{
                position: {
                    x: '62%',
                    y: '78.5%'
                },
                rotation: -36.5
            }],
            [{
                position: {
                    x: '52.6%',
                    y: '74.5%'
                },
                rotation: -37.5
            }],
            [{
                position: {
                    x: '49.5%',
                    y: '77.7%'
                },
                rotation: -27
            }],
            [{
                position: {
                    x: '26.7%',
                    y: '77.2%'
                },
                rotation: 2
            }]
        ]
    },

    torchGuy3: {
        type: 'movieclip',
        scale: {
            y: '40%'
        },
        position: {
            x: '-16%',
            y: '-4.9%'
        },
        /*texture: [
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-0.png',
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-1.png',
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-2.png',
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-3.png',
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-4.png',
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-5.png',
            '/img/partials/blobs-treadmill/torch-guy/3/torch-guy-6.png'
        ],*/
        texture: `sprite:/img/partials/blobs-treadmill/torch-guy-${prefix}.json,torch-guy/3`,
        effectSpriteKey: 'torchGuyEffect',
        effectPositions: [
            [{
                position: {
                    x: '22.5%',
                    y: '70.1%'
                },
                rotation: 22
            }],
            [{
                position: {
                    x: '41.4%',
                    y: '74.8%'
                },
                rotation: 6
            }],
            [{
                position: {
                    x: '29.4%',
                    y: '75.4%'
                },
                rotation: 10
            }],
            [{
                position: {
                    x: '35.6%',
                    y: '67.8%'
                },
                rotation: 4
            }],
            [{
                position: {
                    x: '52.3%',
                    y: '69.9%'
                },
                rotation: -12
            }],
            [{
                position: {
                    x: '79%',
                    y: '69.4%'
                },
                rotation: -34
            }],
            [{
                position: {
                    x: '60.6%',
                    y: '72.5%'
                },
                rotation: -20
            }]
        ]
    },

    torchGuyEffect: {
        scale: {
            x: '1%',
            y: '14%'
        },
        anchor: {
            x: 0.5,
            y: 0
        },
        texture: '/img/partials/blobs-treadmill/torch-effect.png'
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/torchGuy.js